<template>
  <ImageWithAspectRatio :ratio="{ h: 16, v: 9 }">
    <template v-slot:item="{ itemClass }">
      <img
        :src="src"
        :class="itemClass"
      >
    </template>
  </ImageWithAspectRatio>
</template>

<script lang="ts">
import Vue from 'vue';
import ImageWithAspectRatio from '../components/ImageWithAspectRatio.ts.vue';

export default Vue.extend({
  components: {
    ImageWithAspectRatio,
  },
  props: {
    src: {
      type: String,
      required: true,
    },
  },
});
</script>
